import { render, staticRenderFns } from "./EventosAsistidos.vue?vue&type=template&id=1350b519&scoped=true"
import script from "./EventosAsistidos.vue?vue&type=script&lang=js"
export * from "./EventosAsistidos.vue?vue&type=script&lang=js"
import style0 from "./EventosAsistidos.vue?vue&type=style&index=0&id=1350b519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350b519",
  null
  
)

export default component.exports